export const betaAccessRequestKeys = {
  all: ["beta-access-requests"] as const,
  lists: () => [...betaAccessRequestKeys.all, "list"] as const,
  // Nested under `lists()` so the accept/reject mutations, which invalidate
  // `lists()`, still match every param variant by prefix.
  list: (params?: Record<string, unknown>) =>
    [...betaAccessRequestKeys.lists(), params ?? {}] as const,
};
